import { useState } from 'react'
import baseAxios from '../../shared/utils/request' // Import your axios instance
import { useMessage } from '../../shared/hooks/message' // Custom message hook
import { clearStorage } from '../../shared/utils/session' // Handle auth clearing

const username = 'ai'
const password = process.env.REACT_APP_BAZAR_PASSWORD
const domain = process.env.REACT_APP_BAZAR_URL

export function useGetRequestBazar(options = {}) {
    return useApiRequest({ method: 'GET', ...options })
}

export function usePostRequestBazar(options = {}) {
    return useApiRequest({ method: 'POST', ...options })
}

export function usePutRequestBazar(options = {}) {
    return useApiRequest({ method: 'PUT', ...options })
}

export function useDeleteRequestBazar(options = {}) {
    return useApiRequest({ method: 'DELETE', ...options })
}

export function useApiRequest(options = {}) {
    const [response, setResponse] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const showMessage = useMessage()

    async function request(overrideOptions = {}, sync = false) {
        setLoading(true)

        try {
            const { data } = await baseAxios({
                baseURL: options.otherDomain || domain,
                headers: {
                    Authorization: `Basic ${btoa(`${username}:${password}`)}`,
                    'Content-Type': 'application/json',
                },
                ...options,
                ...overrideOptions,
            })

            if (!sync) setResponse(data)
            return { response: data, success: true }
        } catch (e) {
            setError(e.response)

            if (!e.response) {
                showMessage('Check Internet Connection', 'error-msg')
            } else if (e.response.status >= 500) {
                showMessage('Server Error', 'error-msg')
            } else if (e.response.status === 401) {
                clearStorage()
                console.log('Unauthorized')
            }

            return { error: e.response, success: false }
        } finally {
            if (!sync) setLoading(false)
        }
    }

    return {
        loading,
        request,
        error,
        response,
        setResponse,
        setError,
        setLoading,
    }
}
